import type { TFindAssets } from '../api';

interface IIsShowLinkForAllResultArgs<T> {
    limit: number;
    linkSearchPage?: string;
    searchResult: TFindAssets<T>;
}

/** Определяет показывать/не показывать кнопку для перехода на страницу поиска */
export const isShowLinkForAllResult = <T>({
    limit,
    linkSearchPage,
    searchResult,
}: IIsShowLinkForAllResultArgs<T>) =>
    !!linkSearchPage &&
    Object.values(searchResult)
        .map(item => item.totalCount)
        .some(count => Number(count) > limit);
